export default "__VITE_ASSET__C30xwWqd__"